export default "__VITE_ASSET__CHkldgle__"